import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { WorkflowStepNames } from '../../../constants/constants';
import Routes from '../../../constants/routes';
import Notification from '../../Common/Notification';

const IsEHAdminWorkflowStep = ({ user, step, actions }) => {
    if (!user || !step || step.name !== WorkflowStepNames.IsEHAdmin) {
        Notification("error", "Error", "Invalid Step Name: Expected " + WorkflowStepNames.IsEHAdmin + " Actual: " + step.name);
        return (<Redirect to={Routes.LoginPage} />);
    }
    const redirectURL = user.redirectURL;
    const defaultDestination = step.defaultDestination;
    const destination = (redirectURL) ? redirectURL : defaultDestination;

    // This is the end of the Login Workflow for EH Admins, so clear the login
    // workflow object from the redux user
    actions.clearLoginWorkflow();

    return (<Redirect to={destination} />);
};

IsEHAdminWorkflowStep.propTypes = {
    step: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired
}

export default IsEHAdminWorkflowStep;
